import { Controller } from "@hotwired/stimulus";
import SlimSelect from "slim-select";

export default class extends Controller {
  static targets = ["select"];
  static values = {
    multiple: { type: Boolean, default: false},
  };

  connect() {
    const target = this.element
    const isMultiple = target.hasAttribute('multiple') || this.multipleValue

    var options = {
      select: target,
      settings: {
        allowDeselect: true,
        closeOnSelect: !isMultiple,
        allowDeselectOption: true,
      }
    };

    const ss = new SlimSelect(options);
    // if (addable) {
    //   ss.slim.search.input.onkeydown = (event) => {
    //     if (event.key === "Enter") {
    //       event.stopPropagation();
    //       event.preventDefault();
    //     }

    //     if (ss.slim.search.input.value.length >= 3 && event.key === "Enter") {
    //       ss.slim.search.addable.click();
    //     }
    //   };
    // }
  }
}
